var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 2,
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.87646C1.98325 1.87646 2.375 1.48471 2.375 1.00146C2.375 0.518216 1.98325 0.126465 1.5 0.126465C1.01675 0.126465 0.625 0.518216 0.625 1.00146C0.625 1.48471 1.01675 1.87646 1.5 1.87646Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.87646C5.48325 1.87646 5.875 1.48471 5.875 1.00146C5.875 0.518216 5.48325 0.126465 5 0.126465C4.51675 0.126465 4.125 0.518216 4.125 1.00146C4.125 1.48471 4.51675 1.87646 5 1.87646Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.87646C8.98325 1.87646 9.375 1.48471 9.375 1.00146C9.375 0.518216 8.98325 0.126465 8.5 0.126465C8.01675 0.126465 7.625 0.518216 7.625 1.00146C7.625 1.48471 8.01675 1.87646 8.5 1.87646Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot3);
export default __webpack_public_path__ + "static/media/dot3.dedacf7614a20493941785f74b908ca5.svg";
export { ForwardRef as ReactComponent };